import icon from "../../assets/wifi.svg";
import type { Property } from "../../types";

export const wifiTechnology: Property = {
  id: "wifiTechnology",
  title: "wifiTechnology.title",
  icon,
};
